import { Droplets, Leaf, Sun, Wind, Heart, Eye, Baby, ShieldPlus } from 'lucide-react';

export const treatments = [
  {
    id: 1,
    title: "Panchakarma Therapy",
    description: "A comprehensive detoxification and rejuvenation program using five therapeutic procedures to cleanse the body and restore balance.",
    icon: Droplets,
    image: "https://images.unsplash.com/photo-1596178060671-7a80dc8059ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwYW5jaGFrYXJtYSUyMG9pbCUyMG1hc3NhZ2UlMjB0cmVhdG1lbnQlMjBzcGF8ZW58MHx8fHwxNzcwMjI2MDIwfDA&ixlib=rb-4.1.0&q=85",
    benefits: ["Deep detoxification", "Stress relief", "Improved digestion", "Enhanced immunity"]
  },
  {
    id: 2,
    title: "Cancer Care",
    description: "Supportive Ayurvedic care for cancer patients including immunity boosting, pain management, and complementary therapies alongside conventional treatment.",
    icon: ShieldPlus,
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800",
    benefits: ["Immunity support", "Pain management", "Detoxification", "Quality of life improvement"]
  },
  {
    id: 3,
    title: "Eye Care",
    description: "Traditional Ayurvedic treatments for eye health including Netra Tarpana, herbal eye drops, and therapies for vision improvement and eye strain relief.",
    icon: Eye,
    image: "https://images.unsplash.com/photo-1494869042583-f6c911f04b4c?w=800",
    benefits: ["Vision improvement", "Eye strain relief", "Dry eye treatment", "Natural eye care"]
  },
  {
    id: 4,
    title: "Kids & Women Health",
    description: "Specialized Ayurvedic care for children's health, women's wellness, PCOS, fertility support, prenatal and postnatal care with gentle herbal treatments.",
    icon: Baby,
    image: "https://images.unsplash.com/photo-1531983412531-1f49a365ffed?w=800",
    benefits: ["Pediatric care", "Women's wellness", "Fertility support", "Hormonal balance"]
  },
  {
    id: 5,
    title: "Digestive Disorders",
    description: "Personalized treatments for IBS, acidity, constipation, and other digestive issues using herbal medicines and dietary guidance.",
    icon: Leaf,
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800",
    benefits: ["Natural healing", "Root cause treatment", "Dietary guidance", "Long-term relief"]
  },
  {
    id: 6,
    title: "Joint & Spine Care",
    description: "Effective therapies for arthritis, back pain, sciatica, and cervical spondylosis using specialized massage and herbal treatments.",
    icon: Heart,
    image: "https://images.unsplash.com/photo-1649751295468-953038600bef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxwYW5jaGFrYXJtYSUyMG9pbCUyMG1hc3NhZ2UlMjB0cmVhdG1lbnQlMjBzcGF8ZW58MHx8fHwxNzcwMjI2MDIwfDA&ixlib=rb-4.1.0&q=85",
    benefits: ["Pain relief", "Improved mobility", "Strengthening", "Preventive care"]
  },
  {
    id: 7,
    title: "Skin & Hair Care",
    description: "Natural treatments for acne, eczema, psoriasis, hair fall, and premature greying using time-tested Ayurvedic formulations.",
    icon: Sun,
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800",
    benefits: ["Chemical-free care", "Nourishing treatments", "Lasting results", "Holistic approach"]
  },
  {
    id: 8,
    title: "Stress & Sleep Disorders",
    description: "Holistic treatments for anxiety, insomnia, and chronic fatigue using meditation, yoga therapy, and calming herbal medicines.",
    icon: Wind,
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800",
    benefits: ["Mental clarity", "Better sleep", "Reduced anxiety", "Inner peace"]
  }
];

export default treatments;
